import { TextField } from '@mui/material'
import React from 'react'
import InputMask from 'react-input-mask'
import { COLORS } from 'styles/colors'
const formatChars = {
	'1': '[0-2]',
	'2': '[0-9]',
	'3': '[0-5]',
	'4': '[0-9]',
}
type Props = {
	value: string
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	label?: string
	placeholder?: string
	width?: string
	height?: string
	isDisable?: boolean
	isError?: boolean
	helperText?: string
}

const TimeMaskedInput = ({
	value,
	onChange,
	placeholder,
	label = 'Время',
	width,
	height,
	isDisable = false,
	isError = false,
	helperText = ' ',
}: Props) => {
	return (
		<InputMask
			mask='12:34'
			value={value}
			formatChars={formatChars}
			onChange={onChange}
			maskPlaceholder={null}
			disabled={isDisable}
		>
			{inputProps => (
				<TextField
					{...inputProps}
					label={label}
					placeholder={placeholder}
					variant='outlined'
					disabled={isDisable}
					error={isError}
					helperText={helperText}
					inputMode='numeric'
					sx={{
						opacity: !isDisable ? 1 : 0.5,
						width: width || '100%',
						height: height || '54px',
						'.MuiFormHelperText-root': {
							color: isError ? COLORS.error : COLORS.icon,
							margin: '0px',
						},
						'& label': {
							fontSize: value ? '16px' : '14px',
						},
						'& label.Mui-focused': {
							color: COLORS.main,
							fontSize: '16px',
						},
						'& .MuiInputBase-input': {
							fontSize: '14px',
							paddingLeft: '20px',
						},
						'& .MuiOutlinedInput-root': {
							borderRadius: '8px',
							height: height || '54px',
							'& fieldset': {
								border: `1px solid ${COLORS.inputBorder}`,
							},
							'&:hover fieldset': {
								opacity: !isDisable ? 1 : 0.5,
								border: `1px solid ${COLORS.hoverInputBorder}`,
							},
							'&.Mui-focused fieldset': {
								border: `1px solid ${COLORS.main}`,
							},
						},
					}}
					inputProps={{
						style: {
							fontSize: '14px',
							paddingLeft: '10px',
							textAlign: 'center',
						},
						inputMode: 'numeric',
					}}
				/>
			)}
		</InputMask>
	)
}

export default TimeMaskedInput
